import CouponMastersPage from "@/main/components/features/coupon_masters/CouponMastersPage"

const CouponMasters = () => {
	return <CouponMastersPage />
}

export default CouponMasters
